import { useEffect, useState } from 'react';
import { Sun, Moon, MonitorCog } from 'lucide-react';

const STORAGE_KEY = 'ps-ops-theme'; // 'light' | 'dark' | 'system'

// Mirrors the inline script in public/index.html, which applies the persisted choice
// before React mounts (avoids a flash of the wrong theme on load).
function applyTheme(mode) {
  const root = document.documentElement;
  if (mode === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', mode);
}

const OPTIONS = [
  { mode: 'light', label: 'Light theme', icon: Sun },
  { mode: 'system', label: 'Match system theme', icon: MonitorCog },
  { mode: 'dark', label: 'Dark theme', icon: Moon },
];

export default function ThemeToggle() {
  const [mode, setMode] = useState(() => localStorage.getItem(STORAGE_KEY) || 'system');

  useEffect(() => { applyTheme(mode); }, [mode]);

  function choose(next) {
    setMode(next);
    localStorage.setItem(STORAGE_KEY, next);
  }

  return (
    <div className="theme-toggle" role="radiogroup" aria-label="Theme">
      {OPTIONS.map(({ mode: m, label, icon: Icon }) => (
        <button
          key={m}
          type="button"
          role="radio"
          aria-checked={mode === m}
          title={label}
          aria-label={label}
          className={`theme-toggle-btn ${mode === m ? 'active' : ''}`}
          onClick={() => choose(m)}
        >
          <Icon size={14} strokeWidth={1.75} aria-hidden />
        </button>
      ))}
    </div>
  );
}
